/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as React from "react";
import {ButtonHTMLAttributes} from "react";
import '../css/style.css'

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
    additionalClasses?: string;
    isMobile?:boolean
};

const Button: React.FC<ButtonProps> = ({additionalClasses, ...props}) => {
    const buttonClasses = `styled-button${additionalClasses ? ` ${additionalClasses}` : ''}`;
    return <button className={buttonClasses} {...props} />;
};

export default Button;